import type { ResolverMap } from './ResolverMap'
import type { AvailabilityCode } from './AvailabilityCode'

const availabilityByCode = {
  AVAILABLE: 'presentation.availability.available',
  STORE_INACTIVE: 'presentation.availability.storeInactive',
  ORDER_TYPE_NOT_SUPPORTED: 'presentation.availability.orderTypeNotSupported',
  STORE_CLOSED: 'presentation.availability.storeClosed',
  MENU_INACTIVE: 'presentation.availability.menuInactive',
  MENU_NOT_ASSIGNED: 'presentation.availability.menuNotAssigned',
  MENU_ORDER_TYPE_NOT_SUPPORTED: 'presentation.availability.menuOrderTypeNotSupported',
  MENU_CLOSED: 'presentation.availability.menuClosed'
} satisfies Record<AvailabilityCode, string>

export const availabilityResolverMap: ResolverMap<AvailabilityCode> = {
  byCode: availabilityByCode,
  byReason: {},
  genericKey: 'presentation.availability.genericUnavailable'
}
